module.exports = __webpack_public_path__ + "img/Metasploit.606e017.svg";